import { render, staticRenderFns } from "./selectDepartment.vue?vue&type=template&id=755b3472&scoped=true&"
import script from "./selectDepartment.vue?vue&type=script&lang=js&"
export * from "./selectDepartment.vue?vue&type=script&lang=js&"
import style0 from "./selectDepartment.vue?vue&type=style&index=0&id=755b3472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755b3472",
  null
  
)

export default component.exports